import { render } from "./MbaFinance.vue?vue&type=template&id=629c501c"
import script from "./MbaFinance.vue?vue&type=script&lang=js"
export * from "./MbaFinance.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__